export enum ChannelManagementRoutes {
  ChannelSettings = '@trustedshops/tswp-plugin-channel-management:ChannelSettings'
}
